import { CTASection } from "../shared/cta-section";

export const CTA = () => {
  return (
    <CTASection
      id="vmap-cta"
      title="Let us help you understand vegetation change in your area"
      description="VMAP demonstrates what's possible when analysis-ready satellite data, AI models and cloud-native infrastructure come together at continental scale. Haizea Analytics builds the same kind of evidence-based monitoring solutions for governments, NGOs and commercial organisations — whether the challenge is vegetation, water, fire or land use."
      buttons={[
        {
          text: "Explore the VMAP platform",
          href: "https://vmap.au/",
          backgroundColorClass: "bg-haizea-green",
        },
        {
          text: "Talk to us",
          href: "mailto:contact@haizea.com.au",
          backgroundColorClass: "bg-haizea-blue",
        },
      ]}
    />
  );
};
